// function myFunction() {
//   const categoryFeatureds = document.querySelectorAll('.js-category-featured');
//   categoryFeatureds.forEach(categoryFeatured => {
//     // Declare variables
//     var input, filter, ul, li, a, i, txtValue;
//     input = categoryFeatured.querySelector('.js-myInputSearch');
//     filter = input.value.toUpperCase();
//     ul = categoryFeatured.querySelector(".js-myListCategory");
//     li = ul.getElementsByTagName('li');
//     // Loop through all list items, and hide those who don't match the search query
//     for (i = 0; i < li.length; i++) {
//       a = li[i].getElementsByTagName("label")[0];
//       txtValue = a.textContent || a.innerText;
//       if (txtValue.toUpperCase().indexOf(filter) > -1) {
//         li[i].style.display = "";
//       } else {
//         li[i].style.display = "none";
//       }
//     }
//   })
  
// }

if (!customElements.get('category-featured')) {
  customElements.define(
    'category-featured',
    class CategoryFeatured extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.js-myInputSearch');
        
        this.ul = this.querySelector(".js-myListCategory");
        this.li = this.ul.querySelectorAll('li');
        console.log('3333', this.filter)
        this.input.addEventListener('keyup', () => {
          this.li.forEach((li) => {
            this.a = li.querySelector("label");
            this.txtValue = this.a.innerText;
            this.filter = this.input.value.toUpperCase();
            if (this.txtValue.toUpperCase().indexOf(this.filter) > -1) {
              console.log('1111', this.txtValue.toUpperCase().indexOf(this.filter))
              li.style.display = "";
            } else {
              li.style.display = "none";
            }
          })
        })
      }
    }
  );
}

